"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const PopupPanel_vue_1 = require("../common/PopupPanel.vue");
const GameModule_1 = require("@/common/cards/GameModule");
const ClientCardManifest_1 = require("@/client/cards/ClientCardManifest");
const CardType_1 = require("@/common/cards/CardType");
const utils_1 = require("@/common/utils/utils");
function preludeCardNames(module) {
    return (0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byModule)(module))
        .filter((0, ClientCardManifest_1.byType)(CardType_1.CardType.PRELUDE))
        .map(utils_1.toName);
}
const interim = GameModule_1.GAME_MODULES.map((module) => [module, []]);
const ALL_CARDS_BY_MODULE = Object.fromEntries(interim);
(0, ClientCardManifest_1.getCards)((0, ClientCardManifest_1.byType)(CardType_1.CardType.PRELUDE)).forEach((card) => {
    ALL_CARDS_BY_MODULE[card.module].push(card.name);
});
GameModule_1.GAME_MODULES.forEach((module) => ALL_CARDS_BY_MODULE[module].sort());
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'PreludesFilter',
    components: {
        PopupPanel: PopupPanel_vue_1.default,
    },
    props: {
        expansions: {
            type: Object,
            required: true,
        },
        selected: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            filterText: '',
            customPreludesList: false,
            selectedPreludes: this.selected.length > 0 ? this.selected : [
                ...preludeCardNames('prelude'),
                ...this.expansions.promo ? preludeCardNames('promo') : [],
                ...this.expansions.community ? preludeCardNames('community') : [],
                ...this.expansions.moon ? preludeCardNames('moon') : [],
                ...this.expansions.pathfinders ? preludeCardNames('pathfinders') : [],
                ...this.expansions.ceo ? preludeCardNames('ceo') : [],
                ...this.expansions.underworld ? preludeCardNames('underworld') : [],
                ...this.expansions.prelude2 ? preludeCardNames('prelude2') : [],
            ],
        };
    },
    computed: {
        GAME_MODULES() {
            return GameModule_1.GAME_MODULES;
        },
        MODULE_NAMES() {
            return GameModule_1.MODULE_NAMES;
        },
        ALL_CARDS_BY_MODULE() {
            return ALL_CARDS_BY_MODULE;
        },
    },
    methods: {
        updatePreludes(cardNames) {
            this.selectedPreludes = [];
            for (const cardName of this.getItemsByGroup('All')) {
                if (cardNames.includes(cardName)) {
                    this.selectedPreludes.push(cardName);
                }
            }
        },
        getItemsByGroup(group) {
            if (group === 'All')
                return GameModule_1.GAME_MODULES.map((module) => ALL_CARDS_BY_MODULE[module]).flat();
            const corps = ALL_CARDS_BY_MODULE[group];
            if (corps === undefined) {
                console.log('module %s not found', group);
                return [];
            }
            else {
                return corps.slice();
            }
        },
        selectAll(group) {
            const items = this.getItemsByGroup(group);
            for (const item of items) {
                if (this.selectedPreludes.includes(item) === false) {
                    this.selectedPreludes.push(item);
                }
            }
        },
        removeFromSelection(cardName) {
            const itemIdx = this.selectedPreludes.indexOf(cardName);
            if (itemIdx !== -1) {
                this.selectedPreludes.splice(itemIdx, 1);
            }
        },
        selectNone(group) {
            const items = this.getItemsByGroup(group);
            for (const item of items) {
                this.removeFromSelection(item);
            }
        },
        invertSelection(group) {
            const items = this.getItemsByGroup(group);
            for (const idx in items) {
                if (this.selectedPreludes.includes(items[idx])) {
                    this.removeFromSelection(items[idx]);
                }
                else {
                    this.selectedPreludes.push(items[idx]);
                }
            }
        },
        watchSelect(module, enabled) {
            enabled ? this.selectAll(module) : this.selectNone(module);
        },
        compatibility(prelude) {
            return (0, ClientCardManifest_1.getCard)(prelude)?.compatibility ?? [];
        },
        icon(module) {
            let suffix = module;
            if (module === 'colonies')
                suffix = 'colony';
            if (module === 'moon')
                suffix = 'themoon';
            return `create-game-expansion-icon expansion-icon-${suffix}`;
        },
        include(name) {
            const normalized = this.filterText.toLocaleUpperCase();
            if (normalized.length === 0) {
                return true;
            }
            return name.toLocaleUpperCase().includes(normalized);
        },
    },
    watch: {
        selectedPreludes(value) {
            this.$emit('prelude-list-changed', value);
        },
        prelude(enabled) {
            this.watchSelect('prelude', enabled);
        },
        promoCardsOption(enabled) {
            this.watchSelect('promo', enabled);
        },
        communityCardsOption(enabled) {
            this.watchSelect('community', enabled);
        },
        moonExpansion(enabled) {
            this.watchSelect('moon', enabled);
        },
        pathfindersExpansion(enabled) {
            this.watchSelect('pathfinders', enabled);
        },
        ceoExtension(enabled) {
            this.watchSelect('ceo', enabled);
        },
        underworldExpansion(enabled) {
            this.watchSelect('underworld', enabled);
        },
        prelude2Expansion(enabled) {
            this.watchSelect('prelude2', enabled);
        },
    },
});
